import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { useState } from "react";
import IconButton from "../../../components/IconButton";
import Input from "../../../components/Input";
import InputSelect from "../../../components/Input-select";
import { ModalPopUp } from "../../../components/ModalPopUp";
import { toastError, toastSuccess } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { IconFilter, IconTrash } from "../../../icons";
import { splitFormartDate } from "../../../libs/dateUtils";
import { orderByName } from "../../../libs/orderList";
import { remask } from "../../../libs/remask-mask";
import { SwitchBlue } from "../../../libs/switch";
import { filterIsChecked } from "../lib";
import { converteStringToNumber, formatMoney } from "../lib/formatMoney";
import { IGetApproveHours, TimePointProjectUsers } from "../model";
import { getTimeWorkList, timeWorkDelete } from "../service";
import { IOptionList } from "../store/constant";
import useApprovalHours from "../store/useApprovalHours";

const maskModel = ["9,99", "99,99", "999,99", "9.999,99", "99.999,99", "999.999,99"];

export function FilterGroupApproved() {
  const { token, corporationId } = useAuthData();
  const {
    getComponet,
    listUsers,
    listProject,
    monthAndYear,
    setMonthAndYear,
    setSelectProject,
    setRows,
    handleExportCSV,
    getFilterAllTotalWorkList,
    setNeedSpinner,
    listRender,
    state,
    setState,
    modalFilters,
    setModalFilters,
    optionListSelected,
    setOptionListSelected,
    setListExceeded,
    setListBelow,
    setListNormal,
    groupeList,
    setPage,
  } = useApprovalHours();

  const [filterCollaborator, setFilterCollaborator] = useState(0);
  const [filterProject, setFilterProject] = useState(0);

  const [cltOrPj, setCltOrPj] = useState(true);

  function isBoxSelected() {
    const data = listRender.filter((data: any) => data.checked);
    return Boolean(data?.length);
  }

  async function handleDeleteRows() {
    const formData = filterIsChecked(listRender);
    const dataIds: any = formData?.map((data) => data.id);
    const ids: any = [...new Set(dataIds)];
    setNeedSpinner(true);
    const res = await timeWorkDelete(token, ids);
    if (res?.ok) {
      toastSuccess("Registros deletados com sucesso!");
      await getComponet();
      setTimeout(() => {
        setNeedSpinner(false);
      }, 500);
      return;
    }
    if (!res?.ok) return toastError("Erro ao deletar!");
  }

  function handleFilterClick() {
    const userId = filterCollaborator;
    const projectId = filterProject;
    projectId ? setSelectProject(true) : setSelectProject(false);
    const splitYearAndMonth = splitFormartDate(monthAndYear);
    handleExportCSV(splitYearAndMonth, userId, projectId);

    setNeedSpinner(true);
    if (filterCollaborator || filterProject) return getFilterTotalWorkList(token, splitYearAndMonth, userId, projectId);
    getFilterAllTotalWorkList(token, splitYearAndMonth);
  }

  async function getFilterTotalWorkList(token: string, splitYearAndMonth: any, userId?: number, projectId?: number) {
    const res: IGetApproveHours = await getTimeWorkList(token, splitYearAndMonth[0], splitYearAndMonth[1], userId, projectId);
    const listExceededOrder = orderByName(res?.userListExceeded, "userName");
    setListExceeded(listExceededOrder);
    const listBelowOrder = orderByName(res?.userListBelow, "userName");
    setListBelow(listBelowOrder);
    const listNormalOrder = orderByName(res?.userListNormal, "userName");
    setListNormal(listNormalOrder);
    groupeList(res);
    return res;
  }

  function handleToCleanFilter() {
    setFilterCollaborator(0);
    setFilterProject(0);
    const splitYearAndMonth = splitFormartDate(monthAndYear);
    getFilterAllTotalWorkList(token, splitYearAndMonth);
  }

  function totalPaymentAmount() {
    let count = 0;
    listRender.forEach((data: any) => {
      if (data.checked) {
        count += converteStringToNumber(data.payment_amount);
      }
    });
    return String(formatMoney(count)).replaceAll(",", "");
  }

  function setStateFunction() {
    setPage(0);
    setNeedSpinner(true);
    setCltOrPj(!cltOrPj);
    setState((oldState) => !oldState);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 400);
  }

  return (
    <>
      <ModalPopUp title="Filtros" status={modalFilters} onClickCancel={() => setModalFilters(false)}>
        <>
          <div className="filterContainer column">
            <div className="rowFilterContainer limit-filter-container">
              <InputSelect
                className="inputContainer"
                name="search"
                label="Profissional"
                placeholder="Pesquisar"
                onChange={(event: any) => {
                  setFilterCollaborator(event.target.value);
                }}
                value={filterCollaborator}
                list={listUsers}
              />
              <InputSelect
                className="inputContainer"
                name="search"
                label="Projeto"
                placeholder="Pesquisar"
                onChange={(event: any) => {
                  setFilterProject(event.target.value);
                }}
                value={filterProject}
                list={listProject}
              />
              <Input
                setValue={(event: any) => setMonthAndYear(event.target.value)}
                value={monthAndYear}
                name="date"
                label="Periodo"
                className="form-input inputContainer"
                type="month"
                placeholder="Digite o período"
              />
              <InputSelect
                name="listRender"
                className="select-list-render"
                placeholder="Escolha a lista"
                label="Selecione uma lista"
                value={optionListSelected}
                onChange={(e) => setOptionListSelected(+e.target.value)}
                list={IOptionList}
              />
            </div>
            <div className="button-filter-approval-hours flex btnContainer width-100 between">
              <div className="flex">
                <button className="Link btn" onClick={handleFilterClick}>
                  Filtrar
                </button>
                <button className="Link btn bg-secondary" onClick={handleToCleanFilter}>
                  Limpar
                </button>
              </div>

              <div className="switch-modal-filter flex">
                {corporationId == 1 && (
                  <FormControlLabel
                    className="switch"
                    value="top"
                    control={
                      <FormControlLabel
                        style={{ marginLeft: "1px" }}
                        value="top"
                        labelPlacement="end"
                        label="CLT"
                        control={<SwitchBlue checked={state} onChange={setStateFunction} name="checkedB" />}
                      />
                    }
                    label="PJ"
                    labelPlacement="start"
                    style={{ marginBottom: "-10px" }}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      </ModalPopUp>
      {isBoxSelected() && (
        <>
          <div className="row-data-add flex width-100 between">
            <span className="font-source-sans-pro total-payment-amount">Total: R$ {remask(totalPaymentAmount(), maskModel)}</span>
            <IconButton className="center row-trash icon-collaborator" icon={IconTrash} text="" onClick={() => handleDeleteRows()} />
          </div>
        </>
      )}
    </>
  );
}
